import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { CollapsePlugin } from 'bootstrap-vue';
import toTitleCase from 'to-title-case';
import Vue from 'vue';
import vmodal from 'vue-js-modal';
import VueProgressBar from 'vue-progressbar';
// import './utils/registerServiceWorker';
import VueResource from 'vue-resource';
import router from './router';
import store from './store';
import mainView from './views/main.vue';

var VueScrollTo = require('vue-scrollto');

Sentry.init({
  dsn: 'https://cb3bc8d51659402193fcfea01239fef9@sentry.io/1886793',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })]
});

const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'left',
  inverse: false
};

Vue.config.productionTip = false;
Vue.use(VueProgressBar, options);
Vue.filter('titleCase', str =>
  toTitleCase(str)
    .replace(/ii/gi, 'II')
    .replace(/iii/g, 'III')
);
Vue.use(VueScrollTo);
Vue.use(CollapsePlugin);
Vue.use(VueResource);
Vue.use(vmodal, { componentName: 'modal' });

new Vue({
  router,
  store,
  render: h => h(mainView)
}).$mount('#app');
